import type { Maybe } from '@adornis/base/utilTypes.js';
import { roleMapping } from '@ils/permissions/roleMapping.js';
import type { Permissions, Role, User } from './permissions.js';
import { permissions } from './roles/permissions.js';

export const hasPermission = <Resource extends keyof Permissions>(
  user: Maybe<User>,
  resource: Resource,
  action: Permissions[Resource]['actions'],
  data?: Permissions[Resource]['dataType'],
) => {
  if (!user) {
    const check = permissions.noUser.permissions[resource][action];
    if (typeof check === 'function' && check(data)) return true;
    if (check === true) return true;
    return false;
  }
  for (const role of user.roles) {
    const roleName: Role = roleMapping[role.name] ?? role.name;
    const check = permissions[roleName].permissions[resource][action];
    if (typeof check === 'function' && check(user, data)) return true;
    if (check === true) return true;
  }
};
